export default `
precision highp float;
uniform vec4 uColor;
uniform float uDistScale;
uniform float uPeriod;
uniform float uThreshold;
varying float vDist;
void main(void) {
     float normLen  = mod(vDist,uPeriod);
     if(normLen < uThreshold){
        gl_FragColor = uColor;
     } else {
        discard;
     };
}
`;
//# sourceMappingURL=dashLineFragmentShader.js.map